/**
 * Placeholder — re-usable "Coming in Admin Phase 2" page.
 * Every nav item that doesn't yet have a real implementation routes
 * here. NO dead buttons · NO hidden routes.
 */
import React from "react";

export default function Placeholder({
  title,
  phase = "Phase 2",
  description,
  willInclude = [],
  testid,
}) {
  return (
    <div data-testid={testid || "os-placeholder"}>
      <div className="os-pagehead">
        <h1>{title}</h1>
      </div>
      <div className="os-placeholder">
        <span className="tag">Coming in {phase}</span>
        <h2>{title}</h2>
        {description && <p>{description}</p>}
        {willInclude.length > 0 && (
          <>
            <p style={{ color: "var(--os-brass-bright)", marginTop: 8 }}>
              What will live here:
            </p>
            <ul>
              {willInclude.map((w, i) => (
                <li key={i}>{w}</li>
              ))}
            </ul>
          </>
        )}
        <p
          style={{
            marginTop: 18,
            fontSize: 11.5,
            color: "var(--os-faint)",
            fontFamily: "var(--os-font-mono)",
            letterSpacing: "0.04em",
          }}
        >
          Phase 1 stop-rule · No new request schemas before the universal spine.
        </p>
      </div>
    </div>
  );
}
